import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Invite from "@/pages/Invite";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Invite />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
